import { artSrcSet, CARD_ART_WIDTHS, type Character, cardArtBase } from '@guildrise/shared';
import { useState } from 'react';
import './collection-card.css';

const RARITY_LABELS: Readonly<Record<Character['rarity'], string>> = {
  rare: 'Редкая',
  epic: 'Эпическая',
  legendary: 'Легендарная',
  mythic: 'Мифическая',
};

/** Рамка поверх арта; вся подпись находится снаружи карты. */
export function CollectionCard({
  character,
}: {
  readonly character: Character;
}): React.ReactElement {
  const [failedArt, setFailedArt] = useState<string | null>(null);
  const hasArt = character.art.length > 0 && failedArt !== character.art;
  return (
    <figure className="collection-card">
      <div className="collection-card__portrait" aria-hidden="true">
        {hasArt && (
          <img
            className="collection-card__art"
            src={`${cardArtBase(character.art)}-${CARD_ART_WIDTHS[0]}.webp`}
            srcSet={artSrcSet(cardArtBase(character.art), CARD_ART_WIDTHS)}
            sizes="(min-width: 600px) 180px, 44vw"
            alt=""
            loading="lazy"
            decoding="async"
            onError={() => setFailedArt(character.art)}
          />
        )}
        <img
          className="collection-card__frame"
          src={`/art/rarity-frames/${character.rarity}.svg`}
          alt=""
          loading="lazy"
        />
      </div>
      <figcaption>
        <strong>{character.name}</strong>
        <span className="hint">{RARITY_LABELS[character.rarity]}</span>
        {!hasArt && <span className="hint">Арт недоступен</span>}
      </figcaption>
    </figure>
  );
}
